import React from 'react'

const DynamicModal = ({ text, functionToCall, funcParams, setSelectedRolesToUnassign, modalKey, handleCloseModal }: any) => {
    return (
        <div className="modal fade" id={modalKey} aria-labelledby={`${modalKey}Label`} aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content bg-white">
                    <div className="modal-body pt-4 pb-3 text-center main-msg">
                        <p className='mb-0'>{text}</p>
                    </div>
                    <div className="modal-footer justify-content-center border-top-0 pb-4">
                        <button type="button" className="grey-outline-btn mr-3" data-bs-dismiss="modal" onClick={() => handleCloseModal()}>No</button>
                        <button type="button" className="outline-icon-btn" data-bs-dismiss="modal" onClick={() => {
                            functionToCall(funcParams);
                            setSelectedRolesToUnassign !== "single" && setSelectedRolesToUnassign([]);
                        }}>Yes</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DynamicModal